import React, { useEffect, useState } from 'react';
import { Radio, RadioGroup, FormControlLabel, FormControl } from '@mui/material';
import { FORM_KEYS } from '../utills/constant';

function RadioButton({setFormDetailsValue}) {
  const [value, setValue] = useState('JSON');

  useEffect(()=>{
    setFormDetailsValue(FORM_KEYS.OUTPUT_FILE_FORMAT,'JSON')
  },[])

  const handleChange = (event) => {
    setFormDetailsValue(FORM_KEYS.OUTPUT_FILE_FORMAT,event.target.value)
    setValue(event.target.value);
  };

  return (
    <FormControl>
      <RadioGroup 
        row 
        value={value} 
        onChange={handleChange} 
        sx={{ justifyContent: 'flex-start', columnGap: 20 }}
      >
        <FormControlLabel
          value="JSON"
          control={<Radio />}
          label="JSON"
        />
       <FormControlLabel
  value="XML"
  control={<Radio />}
  label="XML"
  sx={{ ml: 3 }}
/>

      </RadioGroup>
    </FormControl>
  );
}

export default RadioButton;
